import { Component, input, output, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSettings } from '@services/settings/app-settings.service';
import { ListCardComponent } from 'app/core/components/list-card/list-card.component';

@Component({
  selector: 'app-entities-list',
  standalone: true,
  imports: [CommonModule, ListCardComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './entities-list.component.html',
  styleUrl: './entities-list.component.scss'
})
export class EntitiesListComponent {
  entities = input<any[]>([]);
  isLoading = input(false);
  edit = output<any>();
  public appSettings = inject(AppSettings);

  skeletonRows = [1, 2, 3, 4, 5, 6];
}
